import { makeStyles } from 'tss-react/mui';

const useStylesMenuItemContent: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  menuItemContentImage: {
    display: 'inline-flex',
    alignItems: 'center',
    '& img': {
      position: 'absolute',
      float: 'right',
      maxWidth: 30,
      maxHeight: 30,
      marginRight: 10,
    },
    '& span': {
      position: 'relative !important',
      margin: '5px 0 5px 40px',
      wordBreak: 'break-word',
      hyphens: 'auto',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      maxWidth: '35vw',
    },
  },
  menuItemContentIcon: {
    '& span': {
      marginLeft: '10px !important',
    },
  },
}));

export default useStylesMenuItemContent;
